import { addBuriedPoint } from '@/api/api'
function buryingPoint(content, type = "页面触达") {
    let times = Date.parse(new Date()) / 1000;
    let data = {
        channelCode: 'DWJRRZ', //渠道代码
        combatCode: 'DWJRRZ', //活动代码
        jsonData: {}, //动态数据
        newName: "", //参与人姓名
        newPhone: '', //参与人手机号
        oldName: "", //老用户姓名
        oldPhone: "", //老用户手机
        reqTsp: times, //请求时间戳
        touchContent: content, //触达内容描述
        touchType: type, //埋点类型，约定关键字
    };
    addBuriedPoint(data)
}
export { buryingPoint }


// WEBPACK FOOTER //
// ./src/utils/utils.js